var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HowThisWorks'),_c('CarDetails',_vm._g({attrs:{"carList":_vm.sortedCars,"selectedIndex":_vm.bubble.userPref,"trips":_vm.trips,"bubble":_vm.bubble},on:{"change":_vm.updateSelected}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }